import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        if (url.startsWith("/login")) {
            return super.parse(url);
        }
        else {
            return super.parse(url.toLowerCase());
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/Utils/LowerCaseUrlSerializer.ts